import { useState } from "react";
import { Link, NavLink, useNavigate } from "@remix-run/react";
import { WaitlistDialog } from "./WaitlistDialog";
import { Logo, TextLogo } from "./Logo";
import { Button } from "@/components/ui/button";
import { Menu, X } from "lucide-react";
import {
  NavigationMenu,
  NavigationMenuContent,
  NavigationMenuItem,
  NavigationMenuLink,
  NavigationMenuList,
  NavigationMenuTrigger,
  navigationMenuTriggerStyle,
} from "@/components/ui/navigation-menu";
import { cn } from "@/lib/utils";
import { useFetcherWithPromise } from "@/hooks/useFetcherWithPromise";
import { action } from "../route";
import { START_ONBOARDING_MAIN } from "@/routes.config";
export function Header() {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  return (
    <>
      <header className="bg-white shadow-sm sticky top-0 z-50">
        <nav className="mx-auto flex max-w-7xl items-center justify-between p-4 lg:px-8">
          <div className="flex lg:flex-1">
            <Link
              to="/"
              className="-m-1.5 p-1.5 flex items-center gap-2 hover:scale-105 transition-all duration-200 hover:bg-gray-100 rounded-md"
            >
              <TextLogo className="text-2xl" />
            </Link>
          </div>

          {/* Mobile menu button */}
          <div className="flex lg:hidden">
            <Button
              variant="ghost"
              size="icon"
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
              className="text-gray-700 transition-transform duration-200 ease-in-out hover:rotate-180"
            >
              {isMobileMenuOpen ? (
                <X className="h-6 w-6" />
              ) : (
                <Menu className="h-6 w-6" />
              )}
            </Button>
          </div>

          {/* Desktop Navigation */}
          <div className="hidden lg:flex">
            <NavigationMenu>
              <NavigationMenuList>
                <NavigationMenuItem>
                  <NavigationMenuLink
                    href="#features"
                    className={navigationMenuTriggerStyle()}
                  >
                    Features
                  </NavigationMenuLink>
                </NavigationMenuItem>

                <NavigationMenuItem>
                  <NavigationMenuLink
                    href="#pricing"
                    className={navigationMenuTriggerStyle()}
                  >
                    Pricing
                  </NavigationMenuLink>
                </NavigationMenuItem>

                <NavigationMenuItem>
                  <Link to={START_ONBOARDING_MAIN()}>
                    <Button
                      size="sm"
                      className="bg-[#E60023] w-fit hover:bg-[#BD081C] hover:text-white text-white ml-4 transition-colors duration-200"
                    >
                      Get Early Access
                    </Button>
                  </Link>
                </NavigationMenuItem>
              </NavigationMenuList>
            </NavigationMenu>
          </div>

          {/* Mobile Navigation */}
          <div
            className={cn(
              "absolute top-full left-0 right-0 bg-white shadow-lg lg:hidden transition-all duration-300 ease-in-out transform",
              isMobileMenuOpen
                ? "opacity-100 translate-y-0"
                : "opacity-0 -translate-y-2 pointer-events-none",
            )}
          >
            <div className="flex flex-col items-end gap-2 px-4 py-3">
              {["Features", "Pricing"].map((item, i) => (
                <Link
                  key={item}
                  to={`#${item.toLowerCase()}`}
                  className={cn(isMobileMenuOpen && "animate-fadeSlideIn")}
                  onClick={() => setIsMobileMenuOpen(false)}
                  style={{
                    animationDelay: `${i * 100}ms`,
                  }}
                >
                  <Button size="sm" variant="link">
                    {item}
                  </Button>
                </Link>
              ))}
              <div
                className={cn(isMobileMenuOpen && "animate-fadeSlideIn")}
                style={{ animationDelay: "200ms" }}
              >
                <Link to={START_ONBOARDING_MAIN()}>
                  <Button
                    variant="outline"
                    size="sm"
                    className="bg-[#E60023] hover:bg-[#BD081C] text-white hover:text-white transition-all duration-200 hover:scale-[1.02]"
                  >
                    Get Early Access
                  </Button>
                </Link>
              </div>
            </div>
          </div>
        </nav>
      </header>
    </>
  );
}
